export default {
    HOLD_ORDER: '[ON HOLD ORDER] HOLD_ORDER',
    HOLD_ORDER_RESULT: '[ON HOLD ORDER] HOLD_ORDER_RESULT',
    HOLD_ORDER_AFTER: '[ON HOLD ORDER] HOLD_ORDER_AFTER',

    DELETE_ON_HOLD_ORDER: '[ON HOLD ORDER] DELETE_ON_HOLD_ORDER',

    CANCEL_ON_HOLD_ORDER: '[ON HOLD ORDER] CANCEL_ON_HOLD_ORDER',
    CANCEL_ON_HOLD_ORDER_AFTER: '[ON HOLD ORDER] CANCEL_ON_HOLD_ORDER_AFTER',

    SEARCH_ORDER: '[ON HOLD ORDER] SEARCH_ORDER',
    SEARCH_ORDER_RESULT: '[ON HOLD ORDER] SEARCH_ORDER_RESULT',
    SEARCH_ORDER_ERROR: '[ON HOLD ORDER] SEARCH_ORDER_ERROR',

    SYNC_ACTION_UPDATE_ON_HOLD_ORDER_FINISH: '[ON HOLD ORDER] SYNC_ACTION_UPDATE_ON_HOLD_ORDER_FINISH',
    SYNC_DELETED_HOLD_ORDER_FINISH: '[ON HOLD ORDER] SYNC_DELETED_HOLD_ORDER_FINISH',

    PAGE_SIZE: 10
}



// WEBPACK FOOTER //
// ./src/view/constant/OnHoldOrderConstant.js